import { render } from "./ManageProjectPage.vue?vue&type=template&id=4da00894"
import script from "./ManageProjectPage.vue?vue&type=script&lang=ts"
export * from "./ManageProjectPage.vue?vue&type=script&lang=ts"

import "./ManageProjectPage.vue?vue&type=style&index=0&id=4da00894&lang=scss"
script.render = render

export default script